import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type {
    CMSArticleImageData,
    CMSArticleRawData,
} from '@/Shared/AutoGenerated/Main'
import CMSBreadcrumb from '@/CMS/Content/Entity/CMSBreadcrumb'

export default class CMSArticle {
    constructor(
        public readonly slug: string,
        public readonly title: string,
        public readonly url: string,
        public readonly excerpt: string,
        public readonly htmlContent: string,
        public readonly isFeatured: boolean,
        public readonly cover: CMSArticleImageData | null,
        public readonly breadcrumbs: CMSBreadcrumb[],
        public readonly publishedAt: string | null,
        public readonly lastUpdatedAt: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getCardImageUrl(): string {
        if (!this.cover) {
            throw new Error('Blog cover is required')
        }

        return this.cover.thumb
    }

    getCoverImageUrl(): string {
        if (!this.cover) {
            throw new Error('Blog cover is required')
        }

        return this.cover.image
    }

    hasCoverAttribution(): boolean {
        return Boolean(
            this.cover?.attributionText && this.cover?.attributionLink,
        )
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: CMSArticleRawData | null,
    ): CMSArticle | null {
        if (entityData === null) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: CMSArticleRawData): CMSArticle {
        return new CMSArticle(
            entityData.slug,
            entityData.title,
            entityData.url,
            entityData.excerpt,
            entityData.htmlContent,
            entityData.isFeatured,
            entityData.cover,
            CMSBreadcrumb.hydrateMultiple(entityData.breadcrumbs),
            entityData.publishedAt,
            entityData.lastUpdatedAt,
        )
    }

    static hydrateMultiple(entitiesData: CMSArticleRawData[]): CMSArticle[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
